/**
 * 广播状态
 */

import {types} from 'mobx-state-tree'
import createStore from "../../lib/create-store";

const initState = {
  broadcastList: [], // 普通跑道
}

const BroadcastItem = types.model('BroadcastItemModel', {})
  .volatile(() => ({
    item: {} // 跑道数据，由于太繁琐了，所以设置为 可变数据
  }))
  .actions((self) => {
    const setItem = (item) => {
      self.item = item
    }
    return {
      setItem
    }
  })

export const Model = types
  .model('BroadcastModel', {
    broadcastList: types.array(BroadcastItem),
    showPopup: false
  })
  .views((self) => {
    return {
      get hasItems() {
        return !!self.broadcastList.length
      }
    }
  })
  .actions((self) => {

    // 将数据添加到 store
    const pushItem = (item) => {
      const itemModel = BroadcastItem.create()
      itemModel.setItem(item)
      self.broadcastList.push(itemModel)
    }

    const removeAll = () => {
      self.broadcastList = []
    }

    const togglePopup = () => {
      self.showPopup = !self.showPopup;
    }

    return {
      pushItem,
      removeAll,
      togglePopup
    }
  })

let {
  store,
  Provider,
  useStore
} = createStore(Model, initState);

export {
  store,
  Provider,
  useStore
}

